<template>
  <div>
    <v-dialog
      v-model="dialogValue"
      max-width="640"
      persistent
      overlay-color="grey darken--1"
      :overlay-opacity="1"
    >
      <v-card
        class="rounded-lg grey lighten-4"
        style="background: white !important"
      >
        <v-card-title class="font-weight-medium">
          Select Sinoa Plan Option
          <v-spacer />
          <v-btn
            icon
            @click="handleClose"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider />

        <v-card-text class="pt-6">
          <div class="text-body-1 font-weight-medium mb-4 white">
            Select Sinoa Plan
          </div>

          <v-sheet
            rounded
            class="pa-4 white"
          >
            <v-row
              v-for="sinoaItem in sinoaItems"
              :key="sinoaItem.id"
              class="mb-4"
              align="center"
              no-gutters
            >
              <v-col cols="7">
                <div
                  class="font-weight-bold"
                >
                  {{ sinoaItem.title }} | {{ sinoaItem.questions }} Questions
                </div>
              </v-col>
              <v-col
                class="d-flex justify-end"
              >
                <v-btn
                  icon
                  @click="selectedId = sinoaItem.id"
                >
                  <v-icon>
                    mdi-plus-circle-outline
                  </v-icon>
                </v-btn>
              </v-col>
              <v-col
                class="text-center font-weight-bold"
              >
                {{ formatCurrency(sinoaItem.price) }}
              </v-col>
              <v-col
                class="d-flex justify-start"
              >
                <v-btn
                  icon
                  :disabled="selectedId !== sinoaItem.id"
                  @click="selectedId = null"
                >
                  <v-icon>
                    mdi-minus-circle-outline
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-checkbox
              v-model="autoRenew"
              class="mt-3"
              hide-details
              color="primary"
            >
              <template #label>
                <span class="font-weight-medium text-body-2">
                  Automatically top up Sinoa Questions when I run out.
                </span>
              </template>
            </v-checkbox>
          </v-sheet>

          <v-divider class="my-6" />

          <div class="d-flex align-center justify-space-between">
            <div class="subtitle-1 font-weight-medium">
              Total
            </div>
            <div
              class="display-1 font-weight-bold primary--text"
            >
              {{ formatCurrency(total) }}
            </div>
          </div>

          <div class="mt-2 success--text text--darken-1">
            *Any coupons or discounts will be applied at checkout.
          </div>
        </v-card-text>

        <v-divider />

        <v-card-actions class="d-flex justify-end py-4">
          <v-btn
            text
            @click="handleClose"
          >
            CANCEL
          </v-btn>
          <v-btn
            color="primary"
            :disabled="basicUser ? false : !selectedItem"
            @click="onCheckout"
          >
            CHECKOUT
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Chargebee />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { formatCurrency } from '@/helpers/formatting';
import CATALOG from '../../components/chatbot/data/_catalog';
import Chargebee from '@/components/chatbot/Chargebee.vue';

export default {
  name: 'SinoaSelection',

  components: {
    Chargebee,
  },

  props: {
    selectedSinoaId: {
      type: String,
      default: 'Sinoa-Intro-Plan',
    },

    basicUser: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      dialogValue: true,
      autoRenew: true,
      selectedId: this.selectedSinoaId || 'Sinoa-Intro-Plan',
    };
  },

  computed: {
    ...mapGetters('subscription', ['isCanadian']),

    country() {
      return this.isCanadian ? 'CA' : 'US';
    },

    sinoaItems() {
      return (CATALOG[this.country] && CATALOG[this.country].sinoa) || [];
    },

    selectedItem() {
      return this.sinoaItems.find((i) => i.id === this.selectedId) || null;
    },

    total() {
      return this.selectedItem?.price || 0;
    },
  },

  methods: {
    ...mapActions('chatbot', ['applyBundleCredit']),

    handleClose() {
      this.dialogValue = false;
      this.$emit('close');
    },

    async OnSuccess(sinoaId) {
      this.$snackbar.success('Sinoa purchased successfully. We’re updating your account…');
      try {
        await this.applyBundleCredit({
          internalName: sinoaId,
          autoRenew: this.autoRenew,
          quantity: 1,
        });
      } catch (e) {
        this.$snackbar.error(e?.message || 'Failed to update your usage.');
      } finally {
        window.location.replace('/dashboard/?openSinoa=true');
      }
    },

    async onCheckout() {
      if (!this.selectedItem) {
        if (this.basicUser) {
          this.$emit('sinoa-select', null, false);
          this.dialogValue = false;
          return;
        }

        this.$snackbar.error('Please select a Sinoa bundle to continue.');
        return;
      }

      const sinoaId = `${this.selectedItem.id}-${this.isCanadian ? 'CAD' : 'USD'}`;
      if (this.basicUser) {
        this.$emit('sinoa-select', sinoaId, this.autoRenew);
        this.dialogValue = false;
        return;
      }

      if (!this.$chargebee || !this.$chargebee.isReady) {
        this.$snackbar.error('Payments are initializing. Please try again.');
        return;
      }

      try {
        await this.$chargebee.openBundleCheckout({
          bundleCart: {
            id: sinoaId,
            quantity: 1,
          },
          autoRenew: this.autoRenew,
          callbacks: {
            loaded: () => {},
            success: () => this.OnSuccess(sinoaId),
            close: () => {},
            error: (err) => {
              this.$snackbar.error(err?.message || err || 'Checkout failed.');
            },
          },
        });
        this.dialogValue = false;
        this.$emit('close');
      } catch (e) {
        this.$snackbar.error('Failed to open checkout. Please try again.');
      }
    },
    formatCurrency,
  },
};
</script>
